import { useMediaQuery } from '@jouzen/ecom-components/hooks/useMediaQuery';
import { BREAKPOINTS } from '@jouzen/ecom-components/v3/consts/breakpoints';
import { Modal } from '@jouzen/ecom-components/v3/Modal';

import { EventType } from '@/analytics/types';
import { useWizardStateContext } from '@/app/[locale]/product/_contexts/WizardStateProvider';
import useMatchUserCountry from '@/app/hooks/useMatchUserCountry';

import DesktopSizeModal from './SizeModalDesktop';
import JapanSizeModal from './SizeModalJapan';
import MobileSizeModal from './SizeModalMobile';

interface ProductSizingModalProps {
  readonly sizeModal: boolean;
  readonly setSizeModal: (sizeModal: boolean) => void;
}

const ProductSizingModal = ({
  sizeModal,
  setSizeModal,
}: ProductSizingModalProps) => {
  const { isAccessory } = useWizardStateContext();
  const isMediumScreen = useMediaQuery(`(min-width: ${BREAKPOINTS.medium}px)`);
  const isJapan = useMatchUserCountry('JP');
  const location = isAccessory ? 'accessory_wizard_pdp' : 'ring_wizard_pdp';

  const handleSizingPageLink = async (loc: string): Promise<void> => {
    await window.ouraAnalytics.track(EventType.LinkClicked, {
      title: 'route_to_size_page',
      location: loc,
    });
  };

  return (
    <Modal
      isOpen={sizeModal}
      onOpenChange={() => setSizeModal(!sizeModal)}
      size="large"
      variant="lightest"
      className="md:rounded-xl"
    >
      {isJapan && (
        <JapanSizeModal
          onSizeLinkClick={() => handleSizingPageLink(location)}
        />
      )}
      {!isJapan && isMediumScreen && (
        <DesktopSizeModal
          onSizeLinkClick={() => handleSizingPageLink(location)}
        />
      )}
      {!isJapan && !isMediumScreen && (
        <MobileSizeModal
          onSizeLinkClick={() => handleSizingPageLink(location)}
        />
      )}
    </Modal>
  );
};

export default ProductSizingModal;
